import { render, staticRenderFns } from "./SystemMessageTriggerModal.vue?vue&type=template&id=2d4b1c82&scoped=true"
import script from "./SystemMessageTriggerModal.vue?vue&type=script&lang=ts"
export * from "./SystemMessageTriggerModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b1c82",
  null
  
)

export default component.exports